import { render } from "./AwardWinningAgency.vue?vue&type=template&id=5a37c21a&scoped=true"
import script from "./AwardWinningAgency.vue?vue&type=script&lang=js"
export * from "./AwardWinningAgency.vue?vue&type=script&lang=js"

import "./AwardWinningAgency.vue?vue&type=style&index=0&id=5a37c21a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a37c21a"]])

export default __exports__